<template>
  <p class="BodyContentCaution">
    <span v-html="cautionIconSvg" class="icon" />
    <span><slot /></span>
  </p>
</template>

<script>
import cautionIconSvg from '~/assets/product-doc/caution-icon.svg?raw'

export default {
  data() {
    return { cautionIconSvg }
  }
}
</script>

<style scoped>
.BodyContentCaution {
  background-color: #FFEBEB;
  padding: var(--spacing-7) var(--spacing-8);
  padding-left: var(--spacing-5);
  border-radius: 10px;
  display: flex;
  gap: var(--spacing-5);
  font-size: var(--font-size-3);
  color: var(--text-color-dark);
}
.icon {
  margin-top: 0.3rem;
}
</style>
